(function () {
  function pad(n){ return String(n).padStart(2,'0'); }
  function parts(ms){
    const s = Math.max(0, Math.floor(ms/1000));
    return {
      d: Math.floor(s/86400),
      h: Math.floor((s % 86400) / 3600),
      m: Math.floor((s % 3600) / 60),
      s: s % 60
    };
  }
  // Always render DD:HH:MM:SS (days can be > 99; pad to 2 anyway)
  function label(p){ return `${pad(p.d)}:${pad(p.h)}:${pad(p.m)}:${pad(p.s)}`; }

  function start(el){
    if (el.__preorderTimer) return;
    const iso = (el.getAttribute('data-countdown-date') || '').replace(/([+\-]\d{2})(\d{2})$/, '$1:$2'); // Safari TZ fix
    const target = new Date(iso).getTime();
    if (isNaN(target)) return;

    function tick(){
      const diff = target - Date.now();
      if (diff <= 0){
        if (el.dataset.doneHide === 'true') el.remove();
        else el.textContent = '00:00:00:00';
        clearInterval(el.__preorderTimer);
        el.__preorderTimer = null;
        return;
      }
      el.textContent = label(parts(diff));
    }

    tick();
    el.__preorderTimer = setInterval(tick, 1000);
  }

  function init(root=document){ root.querySelectorAll('.preorder-countdown').forEach(start); }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => init()) : init();
  document.addEventListener('shopify:section:load', (e)=>init(e.target));
  document.addEventListener('shopify:section:reorder', (e)=>init(e.target));
})();
